export default __webpack_public_path__ + "static/media/RectangleCar1.d5a39b32.png";